


































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { IQuestions } from '@/types';

@Component({
  name: 'FAQ',
  data() {
    return {
      inputText: '',
    };
  },
  computed: {
    ...mapGetters('renters', [
      'faq',
    ]),
  },
  methods: {
    toggleAnswer(e) {
      const question = e.target.closest('.faq-component__questions-types-block__panel-question');
      const answer = question.querySelector('.faq-component__questions-types-block__panel-question-answer');
      const offset = 35;
      if (answer.offsetHeight) {
        answer.style.height = '0px';
        answer.style.marginTop = '0px';
        answer.style.paddingBottom = '0px';
        question.classList.remove('opened-Answer');
      } else {
        answer.style.height = `${answer.scrollHeight + offset}px`;
        answer.style.marginTop = `${offset}px`;
        answer.style.paddingBottom = `${offset}px`;
        question.classList.add('opened-Answer');
      }
    },

    searchingFilter(array) {
      const rightQuestions: IQuestions[] = [];
      if (!this.inputText) {
        return array;
      } else {
        for (const question of array) {
          const questionPosition =  this.parseHtmlToText(question.question)
                                        .toLowerCase()
                                        .indexOf(this.inputText.toLowerCase());
          const answerPosition = this.parseHtmlToText(question.answer)
                                      .toLowerCase()
                                      .indexOf(this.inputText.toLowerCase());
          const newQuestion = {
            question: '',
            answer: '',
          };
          if (questionPosition !== -1) {
            newQuestion.question = this.highlightText(
              question.question,
              questionPosition,
              questionPosition + this.inputText.length,
            );
            newQuestion.answer = question.answer;
            rightQuestions.push(newQuestion);
          } else if (answerPosition !== -1) {
            rightQuestions.push(question);
          }
        }
        return rightQuestions;
      }
    },

    parseHtmlToText(html) {
      const div = document.createElement('div');
      div.innerHTML = html;
      const text = div.innerText;
      div.remove();
      return text;
    },

    highlightText(text, start, end) {
      return `${text.slice(0, start)}<span class='foundText'>${text.slice(start, end)}</span>${text.slice(end)}`;
    },
  },
})
export default class FAQ extends Vue {}
